import React from 'react';

import { useAppConfigStateContext } from '@edx/contexts/app-config';
import { useMonthlyFormattedPrice } from '@edx/hooks/use-monthly-formatted-price';
import { useAuth } from '@edx/hooks/use-auth';
import { ResponsiveImage } from '@edx/types/responsive-image';
import { Hero } from '@edx/components/hero';
import { SignupBanner } from '@edx/components/banners';
import { BannerButtonProps } from '@edx/components/banners/components/signup-banner';
import { BenefitsPanel } from '@edx/components/benefits-panel';

import { LandingProfile, ProfileProps } from './components/profile/landing-profile';
import { ExampleLessons } from './components';
import { VimeoVideo } from '@edx/components/video-tabbed-list';

type Props = {
  profile: ProfileProps;
  hero: {
    bgImage: ResponsiveImage;
    heading: string;
    primaryButton: BannerButtonProps;
  };
  exampleLessons: VimeoVideo[];
};

export const LandingPage: React.FC<Props> = ({ profile, hero, exampleLessons }) => {
  const { projectName } = useAppConfigStateContext();
  const monthlyFormattedPrice = useMonthlyFormattedPrice();
  const { isLoggedOut } = useAuth();

  return (
    <>
      <Hero
        bgImage={hero.bgImage}
        heading={hero.heading}
        primaryButton={hero.primaryButton}
        preheading={`· ${projectName} ·`}
      />

      <BenefitsPanel />

      <ExampleLessons lessons={exampleLessons} />

      {isLoggedOut && (
        <SignupBanner
          className="-mt-20"
          header={
            monthlyFormattedPrice ? `Aprende a tocar el bajo desde sólo ${monthlyFormattedPrice} al mes` : '\u00A0'
          }
          primaryButton={{
            text: 'Regístrate ahora',
            link: '/precio?nav=f',
          }}
        />
      )}

      <LandingProfile
        name={profile.name}
        imageUrl={profile.imageUrl}
        reproductions={profile.reproductions}
        subscribers={profile.subscribers}
        testimonials={profile.testimonials}
        bio={profile.bio}
        link={profile.link}
        socialNetworks={profile.socialNetworks}
      />
    </>
  );
};
